import cn from 'classnames';

import type { TFormImageData } from '@/shared/types';

import { SubjectionItem } from './_components/SubjectionItem/SubjectionItem';
import styles from './SubjectionSection.module.scss';

interface IProp {
  columnTitles: string[];
  columnsData:
    | {
        firstColumnData: string;
        secondColumnData: string;
        thirdColumnData?: TFormImageData;
      }[]
    | null;
}

export const SubjectionSection = ({ columnTitles, columnsData }: IProp) =>
  columnsData && (
    <div className={styles.wrapper}>
      <div className={cn(styles['header-wrapper'], { [styles['header-wrapper-extended']]: columnTitles.length === 3 })}>
        {columnTitles.map((title) => (
          <p key={title}>{title}</p>
        ))}
      </div>
      {columnsData.map(({ firstColumnData, secondColumnData, thirdColumnData }) => (
        <SubjectionItem
          key={firstColumnData}
          firstColumnData={firstColumnData}
          secondColumnData={secondColumnData}
          thirdColumnData={thirdColumnData}
        />
      ))}
    </div>
  );
